// extracted by mini-css-extract-plugin
export default {"statusContainer":"ProjectCheckpointInfoCard_statusContainer__8AYhK","status":"ProjectCheckpointInfoCard_status__gugVR","statusDot":"ProjectCheckpointInfoCard_statusDot__1Jvyz"};